import { CLIENT_PROFILE_COMPONENT_TYPES } from './componentTypes';

export const clientProfileRoutes = {
  profile: 'profile',
  payment: 'payment',
  responsibleGaming: 'responsible-gaming',
  history: 'history',
  settings: 'settings',
  bonuses: 'bonuses',
  communication: 'communication',
};

export const availableClientProfileRoutes = {
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE]: {
    name: 'client_profile',
    icon: 'user-badge-icon',
    link: clientProfileRoutes.profile
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.PAYMENT]: {
    name: 'deposit_withdraw',
    icon: 'wallet-icon',
    link: clientProfileRoutes.payment
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY]: {
    name: 'History',
    icon: 'calendar-icon',
    link: clientProfileRoutes.history
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.BONUSES]: {
    name: 'Bonuses',
    icon: 'bonus-icon',
    link: clientProfileRoutes.bonuses
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.RESPONSIBLE_GAMING]: {
    name: 'Responsible Gaming',
    icon: 'self-regulation-icon',
    link: clientProfileRoutes.responsibleGaming
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.COMMUNICATION]: {
    name: 'Communication',
    icon: 'send-to-mail-icon',
    link: clientProfileRoutes.communication
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.SETTINGS]: {
    name: 'Betslip Settings',
    icon: 'settings-gear-icon',
    link: clientProfileRoutes.settings
  }
}

export const accountRoutes = {
  main: 'main',
  changePassword: 'change-password',
  verifyDocuments: 'verify-documents'
}

export const availableAccountRoutes = {
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE_MAIN]: {
    name: 'main_information',
    icon: 'user-pointer-icon',
    link: accountRoutes.main
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE_CHANGE_PASSWORD]: {
    name: 'change_password',
    icon: 'lock-icon',
    link: accountRoutes.changePassword
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE_VERIFY]: {
    name: 'verify_documents',
    icon: 'shield-icon',
    link: accountRoutes.verifyDocuments
  }
}

export const paymentRoutes = {
  deposit: 'deposit',
  withdrawal: 'withdrawal'
}

export const availablePaymentRoutes = {
  [CLIENT_PROFILE_COMPONENT_TYPES.PAYMENT_DEPOSIT]: {
    name: 'deposit',
    icon: 'deposite-icon',
    link: paymentRoutes.deposit
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.PAYMENT_WITHDRAWAL]: {
    name: 'withdrawal',
    icon: 'withdraw-icon',
    link: paymentRoutes.withdrawal
  }
}

export const historyRoutes = {
  betHistory: 'bet-history',
  myOrders: 'my-orders',
  transactionHistory: 'transaction-history',
  casinoHistory: 'casino-history'
}

export const historyAvailableRoutes = {
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY_BET_HISTORY]: {
    name: 'Bet History',
    icon: 'bet-history-icon',
    link: historyRoutes.betHistory
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY_MY_ORDERS]: {
    name: 'My Orders',
    icon: 'order-bet-icon',
    link: historyRoutes.myOrders
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY_TRANSACTION_HISTORY]: {
    name: 'Transaction History',
    icon: 'casino-history-icon',
    link: historyRoutes.transactionHistory
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY_CASINO_HISTORY]: {
    name: 'Casino History',
    icon: 'transaction-history-icon',
    link: historyRoutes.casinoHistory
  }
}

export const responsibleGamingRoutes = {
  selfExclusion: 'self-exclusion',
  selfRegulation: 'self-regulation',
  depositLimits: 'deposit-limits',
  lossLimits: 'loss-limits',
  realityCheck: 'reality-check'
}

export const responsibleGamingAvailableRoutes = {
  [CLIENT_PROFILE_COMPONENT_TYPES.SELF_REGULATION]: {
    name: 'Self Regulation',
    link: responsibleGamingRoutes.selfRegulation,
    icon: 'self-limitation-icon'
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.SELF_EXCLUSION]: {
    name: 'Self Exclusion',
    link: responsibleGamingRoutes.selfExclusion,
    icon: 'self-exclusion-icon'
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.REALITY_CHECK]: {
    name: 'Reality Check',
    link: responsibleGamingRoutes.realityCheck,
    icon: 'reality-check-icon'
  }
}
